export const profileTh = {
    menu_edit_profile: 'แก้ไขข้อมูลส่วนตัว',
    menu_edit_shipping_address: 'ติดตามพัสดุ',
    menu_invite_friend: 'เชิญเพื่อน..รับแต้มเพิ่ม',
    menu_my_order: 'ติดตามพัสดุ',
    menu_terms: 'เงื่อนไขและการใช้งาน',
    menu_marketing: 'ช่องทางการรับข่าวสาร',
    menu_about: 'เกี่ยวกับเรา',
    menu_contact: 'ติดต่อเรา',
    menu_raq_copy: 'ขอรับสำเนาข้อมูลส่วนบุคคล',
    menu_send_copy: 'ส่งสำเนาข้อมูลส่วนบุคคล<br/>ให้ผู้ควบคุมข้อมูลอื่น',

    logout_headline: 'ออกจากระบบ',
    logout_message: 'คุณต้องการออกจากระบบหรือไม่',
    logout_cancel: 'ยกเลิก',
    logout_confirm: 'ยืนยัน',

    unsubscription_headline: 'ต้องการยกเลิกสมาชิกหรือไม่',
    unsubscription_msg: 'กรณียกเลิกการเป็นสมาชิก<br/>คะแนนและสิทธิพิเศษทั้งหมดจะถูกยกเลิก',
    unsubscription_cancel: 'ยกเลิก',
    unsubscription_confirm: 'ยืนยัน',

    unsubscript_success_headline: 'คุณได้ทำการยกเลิกสมาชิก',
    unsubscript_success_msg: 'ระบบได้ยกเลิกสมาชิกของคุณ<br/>เรียบร้อยแล้ว',
    unsubscript_success_ok: 'ปิด',

    copy_personal: {
        alert_copy: 'ทำรายการข้อมูลส่วนบุคคลสำเร็จ<br/>ระบบได้จัดส่งข้อมูลส่วน<br/>บุคคลไปยังอีเมลเรียบร้อยแล้ว',
        btn: 'ยืนยัน'
    }
}

export const editProfileTh = {
    navname: 'แก้ไขข้อมูลส่วนตัว',
    headline: 'ข้อมูลส่วนตัว',
    name: {
        name: '',
        placeholder: 'ชื่อจริง',
        required: 'กรุณากรอกชื่อจริง',
        too_short: '',
        invalid: '',
    },
    lastname: {
        name: '',
        placeholder: 'นามสกุล',
        required: 'กรุณากรอกนามสกุล',
        too_short: '',
        invalid: '',
    },
    email: {
        name: '',
        placeholder: 'อีเมล์',
        placeholder_r: '(ถ้ามี)',
        required: 'กรุณากรอกอีเมล์',
        too_short: '',
        invalid: 'อีเมล์ของคุณไม่ถูกต้อง',
    },
    contact_number: {
        name: '',
        placeholder: 'เบอร์โทร',
        required: '',
        too_short: '',
        invalid: '',
    },
    birthdate: {
        name: 'วันเกิด',
        notice: '(ต้องมีอายุครบ 20 ปีบริบูรณ์ถึงจะใช้งานได้)',
        required: 'กรุณากรอกข้อมูลให้ครบถ้วน',
        day: {
            name: 'วัน',
            placeholder: 'วัน',
            required: 'กรุณากรอกข้อมูลให้ครบถ้วน',
            too_short: '',
            invalid: '',
        },
        month: {
            name: 'เดือน',
            placeholder: 'เดือน',
            required: 'กรุณากรอกข้อมูลให้ครบถ้วน',
            too_short: '',
            invalid: '',
        },
        year: {
            name: 'ปี พ.ศ.',
            placeholder: 'ปี พ.ศ.',
            required: 'กรุณากรอกข้อมูลให้ครบถ้วน',
            too_short: '',
            invalid: '',
        }
    },

    shop_input_label: 'ร้านตัวแทนจำหน่ายอาหารสัตว์ในพื้นที่ของท่าน',
    shop_text_warning: '(กรุณาตรวจสอบร้านค้าตัวแทนจำหน่ายอาหารสัตว์ที่ท่านใช้บริการ)',
    form_error_label: 'กรุณากรอกข้อมูลให้ครบถ้วน',
    province: {
        name: '',
        placeholder: 'จังหวัด',
        required: 'กรุณากรอกข้อมูลให้ครบถ้วน',
        too_short: '',
        invalid: ''
    },
    shop: {
        name: '',
        placeholder: 'ร้านค้า',
        required: 'กรุณากรอกข้อมูลให้ครบถ้วน',
        too_short: '',
        invalid: ''
    },
    other_shop: {
        name: '',
        placeholder: 'กรุณากรอกชื่อร้านค้า',
        required: 'กรุณากรอกข้อมูลให้ครบถ้วน',
        too_short: '',
        invalid: ''
    },

    fields_required: 'กรุณากรอกข้อมูลให้ครบถ้วน',

    contact_number_remark_1: '* หากต้องการเปลี่ยนเบอร์โทรศัพท์และวันเกิด',
    contact_number_remark_2: 'กรุณาติดต่อ Line : @cpffeedonline',

    livestock_headline: 'กรุณาระบุข้อมูลสัตว์เลี้ยง',
    livestock_unit: 'ตัว',
    livestock_selected_require: 'กรุณากรอกข้อมูลให้ครบถ้วนค่ะ<br/>(บังคับการระบุจำนวนขั้นต่ำ 1 ชนิด)',
    livestock_selected_name_require: 'กรุณาระบุชื่อของข้อมูลสัตว์ที่เลี้ยง',
    livestock_selected_amount_require: 'กรุณาระบุจำนวนของข้อมูลสัตว์ที่เลี้ยง',

    livestock_name_placeholder: 'กรอกชื่อสัตว์',
    livestock_amount_placeholder: 'กรอกจำนวน',
    livestock_add_breed: '+ เพิ่มสัตว์อื่นๆ',
    livestock_remove_breed: 'ลบ',

    edit_profile_btn: 'บันทึก',

    alert_headline: 'เกิดข้อผิดพลาด',
    alert_edit_success_headline: 'แก้ไขข้อมูลส่วนตัว',
    alert_edit_success_msg: 'แก้ไขข้อมูลส่วนตัวสำเร็จ',
    alert_btn: 'ตกลง'
 }
